import RootPage from './insuredactions.page.vue'

let routes = [
  {
    path: 'insured-actions',
    name: 'insured-actions',
    component: RootPage
  },
]

export default routes
